import * as React from 'react';
import { IBigCalendarResource } from './big-calendar-component';

interface ICalendarVehicleHeaderProps {
  resource: IBigCalendarResource;
}
export const CalendarVehicleHeader: React.FunctionComponent<ICalendarVehicleHeaderProps> = (
  props
) => {
  const resource = props.resource;
  return (
    <div
      className={
        'resource-title d-flex align-items-center text-left font-weight-normal'
      }
    >
      <div className="avatar avatar--sm mr-2">
        {/* <img src={require('../../../assets/images/user-noimage.png')} alt="" /> */}
      </div>
      <div>
        <div className="text-truncate font-xm text-gray-800 font-weight-semibold">
          {resource.resourceTitle}
        </div>
        <div className="text-truncate text-center font-xxs text-gray-800 font-weight-semibold">
          {resource.subText}
        </div>
      </div>
    </div>
  );
};
